import { createTheme, colors } from 'design-system';
import { createTheme as createMuiTheme } from '@material-ui/core/styles';

const refTheme = createTheme();
const modifiedTheme: ReturnType<typeof createTheme> = {
  ...createMuiTheme({
    ...refTheme,
    typography: {
      fontFamily: ['Noto Sans SC', 'sans-serif'].join(','),
    },
    overrides: {
      ...refTheme.overrides,
      MuiCheckbox: {
        colorSecondary: {
          padding: 0,
          color: colors.bright_turquoise,
          '&.Mui-checked': {
            color: colors.bright_turquoise,
          },
          '&.Mui-disabled': {
            color: colors.light_silver,
          },
        },
      },
      // Remove when ds2 is imported
      MuiFormControlLabel: {
        root: {
          '& > .MuiIconButton-colorSecondary:hover': {
            backgroundColor: 'rgba(0, 194, 255, 0.04)',
          },
          marginRight: 0,
        },
        label: {
          fontSize: 12,
          lineHeight: '18px',
          letterSpacing: 0.1,
          fontWeight: 500,

          '&.Mui-disabled': {
            color: colors.madison,
          },
        },
      },
    },
  }),
};

export default modifiedTheme;
